import is from '@sindresorhus/is';
import { decode, encodeURL } from 'js-base64';
import { useContext, useMemo } from 'react';
import { z } from 'zod';

import { ApplicationContext } from '~/shared/context/context';

import type { SortOption } from './sort-option';
import { sortOptionSchema } from './sort-option';

type SaveSortOptions = (sort: readonly SortOption[]) => void;

const sortParameterSchema = z
    .string()
    .nullable()
    .transform((sort) => {
        if (is.nullOrUndefined(sort)) {
            return [];
        }

        try {
            return sortOptionSchema.array().parse(JSON.parse(decode(sort)));
        } catch {
            return [];
        }
    });

export const usePersistTableSort = (sortQueryParamName: string): readonly [readonly SortOption[], SaveSortOptions] => {
    const { actions, applicationState } = useContext(ApplicationContext);
    const sortParamValue = applicationState.locationSearchParams.get(sortQueryParamName);
    const sortOptions = useMemo(() => sortParameterSchema.parse(sortParamValue), [sortParamValue]);

    const saveSortOptions: SaveSortOptions = (sort) => {
        if (is.nonEmptyArray(sort)) {
            applicationState.locationSearchParams.set(sortQueryParamName, encodeURL(JSON.stringify(sort)));
            actions.setLocationSearchParams(applicationState.locationSearchParams);

            return;
        }

        actions.deleteLocationSearchParams([sortQueryParamName]);
    };

    return [sortOptions, saveSortOptions];
};
